import { createReducer } from '@reduxjs/toolkit';

import type { IPromo } from './interfaces';
import * as actions from './actions';

const initialState: IPromo = {
  eventViewed: {
    value: false,
    updatedAt: null,
  },
  eventTapped: {
    value: false,
    updatedAt: null,
  },
};

export default createReducer(initialState, (builder) => builder
  .addCase(actions.sendViewed, (state, action) => {
    if (state.eventViewed.value === true) {
      return;
    }
    state.eventViewed = {
      value: true,
      updatedAt: action.payload.callTime,
    };
  })
  .addCase(actions.sendTapped, (state, action) => {
    if (state.eventTapped.value === true) {
      return;
    }
    state.eventTapped = {
      value: true,
      updatedAt: action.payload.callTime,
    };
  }));
